import React, { useMemo, useRef } from "react";
import JoditEditor from "jodit-react";

const JoditEditorComponent = ({ value, onChange, placeholder = "" }) => {
  const editor = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: value ? "" : placeholder,
      height: 500,
      toolbarButtonSize: "middle",
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        // "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "video",
        "table",
        "link",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "|",
        "fullsize",
        "print",
        "preview",
      ],
      uploader: {
        insertImageAsBase64URI: true,
      },
      filebrowser: {
        ajax: {
          url: "",
        },
      },
      imageDefaultWidth: 300,
    }),
    [placeholder, value],
  );

  return (
    <>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={onChange}
      />
    </>
  );
};

export default JoditEditorComponent;
